import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { BarChart, Bar, PieChart, Pie, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { getDashboardApi } from '../../../api/master.api';

const Dashboard = () => {
    const [data, setData] = useState({});
    const [openDistrict, setOpenDistrict] = useState(null);
    const [loading, setLoading] = useState(true);

    const toggleDistrict = (districtName) => {
        setOpenDistrict(openDistrict === districtName ? null : districtName);
    };

    useEffect(() => {
        const getUsers = () => {
            setLoading(true);
            getDashboardApi()
                .then(({ data: body }) => {
                    const dashboardData = body?.data || {};
                    setData(dashboardData);
                })
                .catch((err) => console.error(err))
                .finally(() => setLoading(false));
        };
        getUsers();
    }, []);

    console.log(data);

    // Calculate total district cases
    const totalDistrictCases = data?.district?.reduce((total, district) => {
        return total + district.courts.reduce((sum, court) => sum + court.total, 0);
    }, 0) || 0;


    const formatDigits = (value) => {
        let strValue = String(value);
        const num = Number(value);

        // যদি সংখ্যাটি ১ থেকে ৯ এর মধ্যে হয়, তবে সামনে একটি '0' যোগ করবে
        if (!isNaN(num) && num >= 0 && num <= 9) {
            strValue = strValue.padStart(2, '0');
        }

        // বাংলা কনভার্ট করার অংশটি বাদ দেওয়া হয়েছে, তাই এটি ইংরেজি সংখ্যাই রিটার্ন করবে
        return strValue;
    };



    // Prepare data for Bar Chart - Running vs Disposed Cases
    const barChartData = [
        {
            name: 'আপিল বিভাগ',
            চলমান: parseInt(data?.appeal?.running_cases) || 0,
            নিষ্পত্তিকৃত: parseInt(data?.appeal?.disposed_cases) || 0,
        },
        {
            name: 'হাইকোর্ট',
            চলমান: parseInt(data?.highcourt?.running_cases) || 0,
            নিষ্পত্তিকৃত: parseInt(data?.highcourt?.disposed_cases) || 0,
        },
        {
            name: 'ট্রাইব্যুনাল',
            চলমান: parseInt(data?.tribunal?.running_cases) || 0,
            নিষ্পত্তিকৃত: parseInt(data?.tribunal?.disposed_cases) || 0,
        },
        {
            name: 'অধস্তন আদালত',
            চলমান: data?.district?.reduce((sum, d) => sum + parseInt(d.running_cases), 0) || 0,
            নিষ্পত্তিকৃত: data?.district?.reduce((sum, d) => sum + parseInt(d.disposed_cases), 0) || 0,
        },
    ];

    // Prepare data for Pie Chart - Government For vs Against
    const totalGovtFor = (parseInt(data?.appeal?.govt_for) || 0) +
        (parseInt(data?.highcourt?.govt_for) || 0) +
        (parseInt(data?.tribunal?.govt_for) || 0);

    const totalGovtAgainst = (parseInt(data?.appeal?.govt_against) || 0) +
        (parseInt(data?.highcourt?.govt_against) || 0) +
        (parseInt(data?.tribunal?.govt_against) || 0);

    const pieChartData = [
        { name: ' পক্ষে', value: totalGovtFor },
        { name: ' বিপক্ষে', value: totalGovtAgainst },
    ];

    const COLORS = ['#10b981', '#ef4444'];

    // Custom CSS
    const styles = `
        .dashboard-card {
            transition: all 0.3s ease;
            border-left: 4px solid transparent;
        }
        .dashboard-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 8px 25px rgba(0,0,0,0.15) !important;
        }
        .appeal-card {
            border-left-color:rgb(35, 147, 134);
            background: rgb(5, 121, 108);
        }
        .highcourt-card {
            border-left-color: rgb(5, 121, 108);
            background: rgb(5, 121, 108);
        }
        .district-card {
            border-left-color:rgb(5, 121, 108);
            background: rgb(5, 121, 108);
        }
        .stat-badge {
            font-size: 0.9rem;
            padding: 0.5rem 0.75rem;
            border-radius: 20px;
        }
        .court-item {
            transition: background-color 0.2s ease;
            border-radius: 8px;
            padding: 0.5rem;
        }
        .court-item:hover {
            background-color: rgba(255, 255, 255, 0.3);
        }
        .district-header {
            padding: 0.75rem;
            border-radius: 8px;
            transition: background-color 0.2s ease;
        }
        .district-header:hover {
            background-color: rgba(255, 255, 255, 0.2);
        }
        .icon-container {
            width: 60px;
            height: 60px;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .loading-container {
            min-height: 400px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .summary-card {
            background: rgb(104, 48, 145);
            color: white;
            border-radius: 15px;
        }
        .summary-important-card {
            background: rgb(104, 48, 145);
            color: white;
        }
        .summary-card h4 {
            margin-bottom: 0.25rem;
        }
        .chart-card {
            background: white;
            border-radius: 15px;
            box-shadow: 0 4px 6px rgba(0,0,0,0.1);
        }
    `;

    if (loading) {
        return (
            <div className="page-wrapper">
                <div className="loading-container">
                    <div className="text-center">
                        <div className="spinner-border text-primary" style={{ width: '3rem', height: '3rem' }} role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-3 text-muted">ড্যাশবোর্ড লোড হচ্ছে...</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="page-wrapper ps-3">
            <style>{styles}</style>

            <div className="container-fluid py-4" style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
                {/* Header - Removed as requested */}

                <div className="row g-4">
                    {/* Left Side - Court Cards (col-6) */}
                    <div className="col-lg-6">
                        <div className="row g-4">
                            {/* Appeal Division */}
                            <div className="col-6">
                                <div className="card shadow-sm h-100 border-0 dashboard-card appeal-card">
                                    <div className="card-header bg-transparent border-0 pb-0">
                                        <div className="d-flex align-items-center">
                                            <div className="icon-container text-white" style={{ backgroundColor: 'rgba(255, 255, 255, 0.3)' }}>
                                                <i className="fas fa-balance-scale fa-lg" style={{ zIndex: '1' }}></i>
                                            </div>
                                            <div className="ms-3">
                                                <h5 className="card-title mb-0 text-white">আপিল বিভাগ</h5>
                                                <small className="text-white">সুপ্রিম কোর্টের উচ্চতর বিভাগ</small>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="row g-2">
                                            <div className="col-6">
                                                <Link to="/report/appeal-court/running-case" className="text-decoration-none" style={{ color: 'inherit' }}>
                                                    <div className="text-center p-3 rounded" style={{ backgroundColor: 'rgba(255, 255, 255, 0.25)' }}>
                                                        <h4 className="text-white mb-1">{formatDigits(parseInt(data?.appeal?.running_cases)) ?? 0}</h4>
                                                        <small className="text-white">চলমান মামলা</small>
                                                    </div>
                                                </Link>
                                            </div>
                                            <div className="col-6">
                                                <Link to="/report/appeal-court/close-case" className="text-decoration-none" style={{ color: 'inherit' }}>
                                                    <div className="text-center p-3 rounded" style={{ backgroundColor: 'rgba(255, 255, 255, 0.25)' }}>
                                                        <h4 className="text-white mb-1">{formatDigits(parseInt(data?.appeal?.disposed_cases)) ?? 0}</h4>
                                                        <small className="text-white">নিষ্পত্তিকৃত</small>
                                                    </div>
                                                </Link>
                                            </div>
                                        </div>

                                        <div className="mt-3 pt-3" style={{ borderTop: '1px solid rgba(255, 255, 255, 0.3)' }}>
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                <span className="text-white"> পক্ষে</span>
                                                <span className="badge stat-badge text-white" style={{ backgroundColor: 'rgba(255, 255, 255, 0.3)' }}>
                                                    {formatDigits(parseInt(data?.appeal?.govt_for)) ?? 0}
                                                </span>
                                            </div>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <span className="text-white"> বিপক্ষে</span>
                                                <span className="badge stat-badge text-white" style={{ backgroundColor: 'rgba(255, 255, 255, 0.3)' }}>
                                                    {formatDigits(parseInt(data?.appeal?.govt_against)) ?? 0}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* High Court Division */}
                            <div className="col-6">
                                <div className="card shadow-sm h-100 border-0 dashboard-card highcourt-card">
                                    <div className="card-header bg-transparent border-0 pb-0">
                                        <div className="d-flex align-items-center">
                                            <div className="icon-container text-white" style={{ backgroundColor: 'rgba(255, 255, 255, 0.3)' }}>
                                                <i className="fas fa-university fa-lg" style={{ zIndex: '1' }}></i>
                                            </div>
                                            <div className="ms-3">
                                                <h5 className="card-title mb-0 text-white">হাইকোর্ট বিভাগ</h5>
                                                <small className="text-white">সুপ্রিম কোর্টের নিম্নতর বিভাগ</small>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="row g-2">
                                            <div className="col-6">
                                                <Link to="/report/high-court/running-case" className="text-decoration-none" style={{ color: 'inherit' }}>
                                                    <div className="text-center p-3 rounded" style={{ backgroundColor: 'rgba(255, 255, 255, 0.25)' }}>
                                                        <h4 className="text-white mb-1">{formatDigits(parseInt(data?.highcourt?.running_cases)) ?? 0}</h4>
                                                        <small className="text-white">চলমান মামলা</small>
                                                    </div>
                                                </Link>
                                            </div>
                                            <div className="col-6">
                                                <Link to="/report/high-court/close-case" className="text-decoration-none" style={{ color: 'inherit' }}>
                                                    <div className="text-center p-3 rounded" style={{ backgroundColor: 'rgba(255, 255, 255, 0.25)' }}>
                                                        <h4 className="text-white mb-1">{formatDigits(parseInt(data?.highcourt?.disposed_cases)) ?? 0}</h4>
                                                        <small className="text-white">নিষ্পত্তিকৃত</small>
                                                    </div>
                                                </Link>
                                            </div>
                                        </div>

                                        <div className="mt-3 pt-3" style={{ borderTop: '1px solid rgba(255, 255, 255, 0.3)' }}>
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                <span className="text-white"> পক্ষে</span>
                                                <span className="badge stat-badge text-white" style={{ backgroundColor: 'rgba(255, 255, 255, 0.3)' }}>
                                                    {formatDigits(parseInt(data?.highcourt?.govt_for)) ?? 0}
                                                </span>
                                            </div>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <span className="text-white"> বিপক্ষে</span>
                                                <span className="badge stat-badge text-white" style={{ backgroundColor: 'rgba(255, 255, 255, 0.3)' }}>
                                                    {formatDigits(parseInt(data?.highcourt?.govt_against)) ?? 0}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Tribunal */}
                            <div className="col-6">
                                <div className="card shadow-sm h-100 border-0 dashboard-card highcourt-card">
                                    <div className="card-header bg-transparent border-0 pb-0">
                                        <div className="d-flex align-items-center">
                                            <div className="icon-container text-white" style={{ backgroundColor: 'rgba(255, 255, 255, 0.3)' }}>
                                                <i className="fas fa-university fa-lg" style={{ zIndex: '1' }}></i>
                                            </div>
                                            <div className="ms-3">
                                                <h5 className="card-title mb-0 text-white">THREE-MEMBER ARBITRAL TRIBUNAL, DHAKA</h5>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="row g-2">
                                            <div className="col-6">
                                                <Link to="/report/tribunal-court/running-case" className="text-decoration-none" style={{ color: 'inherit' }}>
                                                    <div className="text-center p-3 rounded" style={{ backgroundColor: 'rgba(255, 255, 255, 0.25)' }}>
                                                        <h4 className="text-white mb-1">{formatDigits(parseInt(data?.tribunal?.running_cases)) ?? 0}</h4>
                                                        <small className="text-white">চলমান মামলা</small>
                                                    </div>
                                                </Link>
                                            </div>
                                            <div className="col-6">
                                                <Link to="/report/tribunal-court/close-case" className="text-decoration-none" style={{ color: 'inherit' }}>
                                                    <div className="text-center p-3 rounded" style={{ backgroundColor: 'rgba(255, 255, 255, 0.25)' }}>
                                                        <h4 className="text-white mb-1">{formatDigits(parseInt(data?.tribunal?.disposed_cases)) ?? 0}</h4>
                                                        <small className="text-white">নিষ্পত্তিকৃত</small>
                                                    </div>
                                                </Link>
                                            </div>
                                        </div>

                                        <div className="mt-3 pt-3" style={{ borderTop: '1px solid rgba(255, 255, 255, 0.3)' }}>
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                <span className="text-white"> পক্ষে</span>
                                                <span className="badge stat-badge text-white" style={{ backgroundColor: 'rgba(255, 255, 255, 0.3)' }}>
                                                    {formatDigits(parseInt(data?.tribunal?.govt_for)) ?? 0}
                                                </span>
                                            </div>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <span className="text-white"> বিপক্ষে</span>
                                                <span className="badge stat-badge text-white" style={{ backgroundColor: 'rgba(255, 255, 255, 0.3)' }}>
                                                    {formatDigits(parseInt(data?.tribunal?.govt_against)) ?? 0}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* District Courts */}
                            <div className="col-6">
                                <div className="card shadow-sm h-100 border-0 dashboard-card district-card">
                                    <div className="card-header bg-transparent border-0 pb-0">
                                        <div className="d-flex align-items-center">
                                            <div className="icon-container text-white" style={{ backgroundColor: 'rgba(255, 255, 255, 0.3)' }}>
                                                <i className="fas fa-gavel fa-lg" style={{ zIndex: '1' }}></i>
                                            </div>
                                            <Link to="/report/district-court/all-case" className="text-decoration-none" style={{ color: 'inherit' }}>
                                                <div className="ms-3">
                                                    <h5 className="card-title mb-0 text-white">অন্যান্য অধস্তন আদালত</h5>
                                                    <small className="text-white">বিভিন্ন জেলার আদালত সমূহ</small>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="district-list" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                            {data?.district?.map((district, index) => (
                                                <div key={index} className="mb-3">
                                                    <div
                                                        className="district-header d-flex justify-content-between align-items-center cursor-pointer"
                                                        onClick={() => toggleDistrict(district.district_name)}
                                                        style={{ cursor: "pointer", backgroundColor: 'rgba(255, 255, 255, 0.25)', padding: '0.75rem', borderRadius: '8px' }}
                                                    >
                                                        <div>
                                                            <span className="text-white">
                                                                {district.district_name}
                                                            </span>
                                                            <small className="text-white ms-2">
                                                                - {formatDigits(district.courts.reduce((sum, court) => sum + parseInt(court.total), 0))} ( চলমান- {formatDigits(parseInt(district.running_cases))}, নিষ্পত্তিকৃত- {formatDigits(parseInt(district.disposed_cases))} )
                                                            </small>
                                                        </div>
                                                        <i
                                                            className={`fas fa-chevron-${openDistrict === district.district_name ? "up" : "down"} text-white`}
                                                        ></i>
                                                    </div>

                                                    {openDistrict === district.district_name && (
                                                        <div className="mt-2 ps-3">
                                                            {district.courts.map((court, idx) => (
                                                                <Link to={`/courtwise-report/${court.court_type_id}`} className="text-decoration-none" style={{ color: 'inherit' }}>

                                                                    <div
                                                                        className="court-item d-flex justify-content-between align-items-center mb-2"
                                                                        key={idx}
                                                                        style={{ backgroundColor: 'rgba(255, 255, 255, 0.2)', padding: '0.5rem', borderRadius: '8px' }}
                                                                    >
                                                                        <div>
                                                                            <span className="text-white small">
                                                                                {court.court_type_name}
                                                                            </span>
                                                                        </div>
                                                                        <span className="badge rounded-pill text-white" style={{ backgroundColor: 'rgba(255, 255, 255, 0.3)' }}>
                                                                            {formatDigits(parseInt(court.total))}
                                                                        </span>
                                                                    </div>
                                                                </Link>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Updated Summary Stats */}

                            <div className="col-12">
                                <div className="card shadow-sm border-0 summary-important-card">
                                    <Link to="/important-running-case" style={{textDecoration:"none"}}>
                                        <h4 className="card-header bg-transparent border-0 text-white">গুরুত্বপূর্ণ চলমান মামলা {formatDigits(parseInt(data?.important_cases?.important_cases)) || 0} </h4>
                                    </Link>
                                </div>
                            </div>

                        </div>
                    </div>

                    {/* Right Side - Charts (col-6) */}
                    <div className="col-lg-6">
                        <div className="row g-4">
                            {/* Bar Chart */}
                            <div className="col-12">
                                <div className="card shadow-sm border-0 chart-card">
                                    <div className="card-header bg-transparent border-0">
                                        <h5 className="card-title mb-0 text-dark">চলমান ও নিষ্পত্তিকৃত মামলার তুলনা</h5>
                                    </div>
                                    <div className="card-body">
                                        <ResponsiveContainer width="100%" height={300}>
                                            <BarChart data={barChartData}>
                                                <CartesianGrid strokeDasharray="3 3" />
                                                <XAxis dataKey="name" />
                                                <YAxis />
                                                <Tooltip />
                                                <Legend />
                                                <Bar dataKey="চলমান" fill="#3b82f6" />
                                                <Bar dataKey="নিষ্পত্তিকৃত" fill="#10b981" />
                                            </BarChart>
                                        </ResponsiveContainer>
                                    </div>
                                </div>
                            </div>

                            {/* Pie Chart */}
                            <div className="col-12">
                                <div className="card shadow-sm border-0 chart-card">
                                    <div className="card-header bg-transparent border-0">
                                        <h5 className="card-title mb-0 text-dark">নিষ্পত্তিকৃত মামলার বিবরণ</h5>
                                    </div>
                                    <div className="card-body">
                                        <ResponsiveContainer width="100%" height={250}>
                                            <PieChart>
                                                <Pie
                                                    data={pieChartData}
                                                    cx="50%"
                                                    cy="50%"
                                                    labelLine={false}
                                                    label={({ name, percent, value }) => `${name}: ${value} (${(percent * 100).toFixed(0)}%)`}
                                                    outerRadius={120}
                                                    fill="#8884d8"
                                                    dataKey="value"
                                                >
                                                    {pieChartData.map((entry, index) => (
                                                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                                    ))}
                                                </Pie>
                                                <Tooltip />
                                            </PieChart>
                                        </ResponsiveContainer>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>







                <div className="row mt-4">
                    <div className="col-12">
                        <div className="card shadow-sm border-0 summary-card">
                            <div className="card-body py-4">
                                <div className="row text-center">
                                    {/* Appeal Division Cases */}
                                    <div className="col-md-2  col-6 border-end border-light border-opacity-25">
                                        <h4 className="text-white mb-1">
                                            {formatDigits(parseInt(data?.appeal?.running_cases)) || 0}
                                        </h4>
                                        <small className="text-white">আপিল বিভাগ</small>
                                        <br />
                                        <small className="text-white ">চলমান মামলা</small>
                                    </div>

                                    {/* High Court Division Cases */}
                                    <div className="col-md-2 col-6 border-end border-light border-opacity-25">
                                        <h4 className="text-white mb-1">
                                            {formatDigits(parseInt(data?.highcourt?.running_cases)) || 0}
                                        </h4>
                                        <small className="text-white">হাইকোর্ট বিভাগ</small>
                                        <br />
                                        <small className="text-white ">চলমান মামলা</small>
                                    </div>
                                    <div className="col-md-2 col-6 border-end border-light border-opacity-25">
                                        <h4 className="text-white mb-1">
                                            {formatDigits(parseInt(data?.tribunal?.running_cases)) || 0}
                                        </h4>
                                        <small className="text-white">THREE-MEMBER ARBITRAL TRIBUNAL</small>
                                        <br />
                                        <small className="text-white ">চলমান মামলা</small>
                                    </div>

                                    {/* District Court Cases */}
                                    <div className="col-md-2 col-6 border-end border-light border-opacity-25">
                                        <h4 className="text-white mb-1">
                                            {/* {totalDistrictCases} */}
                                            {formatDigits(data?.district?.reduce((sum, court) => sum + parseInt(court.running_cases), 0)) || 0}
                                        </h4>
                                        <small className="text-white">অন্যান্য অধস্তন আদালত </small>
                                        <br />
                                        <small className="text-white ">মোট চলমান মামলা</small>
                                    </div>

                                    {/* Total Running Cases */}
                                    <div className="col-md-2 col-6 border-end border-light border-opacity-25">
                                        <h4 className="text-white mb-1">
                                            {(parseInt(data?.appeal?.running_cases) || 0) + (parseInt(data?.tribunal?.running_cases) || 0) +
                                                (parseInt(data?.highcourt?.running_cases) || 0) +
                                                (data?.district?.reduce((sum, court) => sum + parseInt(court.running_cases), 0) || 0)}
                                        </h4>
                                        <small className="text-white">সকল আদালত</small>
                                        <br />
                                        <small className="text-white ">মোট চলমান মামলা</small>
                                    </div>

                                    {/* Government For */}
                                    <div className="col-md-2 col-6 text-center ">
                                        <h5 className="text-white mb-1 fw-bold">
                                            মোট নিষ্পত্তিকৃত মামলা : {formatDigits(parseInt(totalGovtFor) + parseInt(totalGovtAgainst))}
                                        </h5>

                                        <div >
                                            <small className="text-white"> পক্ষে - {formatDigits(parseInt(totalGovtFor))}</small>
                                            <br />
                                            <small className="text-white"> বিপক্ষে - {formatDigits(parseInt(totalGovtAgainst))}</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Individual Court Statistics */}
                {/* <div className="row mt-4">
                    <div className="col-12">
                        <div className="card shadow-sm border-0">
                            <div className="card-header bg-transparent border-0">
                                <h5 className="card-title mb-0 text-dark">আদালত অনুযায়ী মামলা সংখ্যা</h5>
                            </div>
                            <div className="card-body">
                                <div className="row text-center">
                                  
                <div className="col-lg-3 col-md-6 mb-3">
                    <div className="p-3 rounded h-100" style={{ backgroundColor: 'rgb(5, 121, 108)' }}>
                        <h6 className="mb-3 text-white">আপিল বিভাগ</h6>
                        <div className="row">
                            <div className="col-6">
                                <div className="mb-3">
                                    <h5 className="text-white">{data?.appeal?.running_cases || 0}</h5>
                                    <small className="text-white" >চলমান</small>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="mb-3">
                                    <h5 className="text-white">{data?.appeal?.disposed_cases || 0}</h5>
                                    <small className="text-white" >নিষ্পত্তিকৃত</small>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="mb-3">
                                    <h5 className="text-white">{data?.appeal?.govt_for || 0}</h5>
                                    <small className="text-white" > পক্ষে</small>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="mb-3">
                                    <h5 className="text-white">{data?.appeal?.govt_against || 0}</h5>
                                    <small className="text-white" > বিপক্ষে</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

              
                <div className="col-lg-3 col-md-6 mb-3">
                    <div className="p-3 rounded h-100" style={{ backgroundColor: 'rgb(5, 121, 108)' }}>
                        <h6 className="mb-3 text-white">হাইকোর্ট বিভাগ</h6>
                        <div className="row">
                            <div className="col-6">
                                <div className="mb-3">
                                    <h5 className="text-white">{data?.highcourt?.running_cases || 0}</h5>
                                    <small className="text-white" >চলমান</small>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="mb-3">
                                    <h5 className="text-white">{data?.highcourt?.disposed_cases || 0}</h5>
                                    <small className="text-white" >নিষ্পত্তিকৃত</small>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="mb-3">
                                    <h5 className="text-white">{data?.highcourt?.govt_for || 0}</h5>
                                    <small className="text-white" >সরকারের পক্ষে</small>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="mb-3">
                                    <h5 className="text-white">{data?.highcourt?.govt_against || 0}</h5>
                                    <small className="text-white" >সরকারের বিপক্ষে</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-lg-3 col-md-6 mb-3">
                    <div className="p-3 rounded h-100" style={{ backgroundColor: 'rgb(5, 121, 108)' }}>
                        <h6 className="mb-3 text-white">THREE-MEMBER ARBITRAL TRIBUNAL, DHAKA</h6>
                        <div className="row">
                            <div className="col-6">
                                <div className="mb-3">
                                    <h5 className="text-white">{data?.tribunal?.running_cases || 0}</h5>
                                    <small className="text-white" >চলমান</small>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="mb-3">
                                    <h5 className="text-white">{data?.tribunal?.disposed_cases || 0}</h5>
                                    <small className="text-white" >নিষ্পত্তিকৃত</small>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="mb-3">
                                    <h5 className="text-white">{data?.tribunal?.govt_for || 0}</h5>
                                    <small className="text-white" >সরকারের পক্ষে</small>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="mb-3">
                                    <h5 className="text-white">{data?.tribunal?.govt_against || 0}</h5>
                                    <small className="text-white" >সরকারের বিপক্ষে</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

              
                <div className="col-lg-3 col-md-12 mb-3">
                    <div className="p-3 rounded h-100" style={{ backgroundColor: 'rgb(5, 121, 108)' }}>
                        <h6 className="mb-3 text-white">অন্যান্য অধস্তন আদালত </h6>
                        <div className="text-center">
                            <h2 className="mb-2 text-white">{totalDistrictCases}</h2>
                            <small className="text-white" >মোট চলমান মামলা</small>
                        </div>
                        <div className="mt-3">
                            <small className="text-white" >
                                {data?.district?.length || 0} টি জেলার আদালত সমূহ
                            </small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
                        </div >
                    </div >
                </div > */}
            </div >
        </div >
    );
};

export default Dashboard;